/**
 * @fileoverview Syndicator Showdown — Stable share reveal rules
 * @module utils/revealRules
 *
 * Single source of truth for "can this public share page show exact runner
 * selections right now?" — used by ShareStablePage and reusable share
 * components so the rule is identical everywhere it's enforced. Kept as a
 * pure function (no Firestore/React) so it's trivially unit-testable.
 */

export const REVEAL_MODES = {
  IMMEDIATE: 'immediate',
  AFTER_ENTRIES_CLOSE: 'after_entries_close',
};

/**
 * @param {Object} params
 * @param {string} [params.revealMode] - 'immediate' | 'after_entries_close'
 * @param {boolean} [params.entriesClosed] - true once the Showdown's entries have closed
 * @returns {boolean} true if exact runner selections may be shown
 */
export function canRevealSelections({ revealMode, entriesClosed } = {}) {
  return revealMode === REVEAL_MODES.IMMEDIATE || !!entriesClosed;
}

/**
 * Player-facing teaser copy shown in place of selections before reveal.
 * @param {string} stableName
 * @returns {string}
 */
export function buildRevealTeaserText(stableName) {
  const name = stableName || 'This player';
  return `${name} has entered this Showdown. Selections will reveal after entries close.`;
}
